import { useAuthStore } from '@/stores/login'
import { updateUserInfo } from '@/utils/userInfo'
import { loading } from '@/utils/loading'
import { showToast } from 'vant'

export const isTudoApp = window.navigator.userAgent.indexOf('tudoApp') > -1

// function sleep(ms: number) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }

const invokeMethod = async (name: string, params: string): Promise<any> => {
  try {
    // console.log('invokeMethod');
    if (window.flutter_inappwebview?.callHandler) {
      // console.log('window.flutter_inappwebview.callHandler');
      return await window.flutter_inappwebview.callHandler(name, params)
    } else {
      // await sleep(2000)
      setTimeout(() => {
        window.location.replace(location.href)
      }, 2000)
    }
  } catch (error) {
    console.log(error)
    showToast(JSON.stringify(error))
    return ''
  }
}

export const tuduLogin = async () => {
  loading.show()
  const res = await invokeMethod('flutterBridge', 'getToken')
  loading.hide()
  // console.log(res)

  if (!res) {
    return {}
  }
  const authStore = useAuthStore()
  const data = res.data
  const { stanToken: token, language } = data
  // alert('token:' + token)
  authStore.setAccessToken(token)
  localStorage.setItem('sandsTalkTenantId', '1000')
  localStorage.setItem('sandsTalkToken', token)
  await updateUserInfo()
  return res.data || {}
}

export const tudoGetLang = async () => {
  const res = await invokeMethod('flutterBridge', 'getLang')
  if (!res) {
    return 'zh-cn'
  }
  const data = res.data
  const { language } = data
  return language
}

export const tudoSetTitle = (str: string) => {
  window.flutter_inappwebview.callHandler('flutterSetTitleName', str)
}

export const flutterSetHoriVerti = (isFull: boolean) => {
  window.flutter_inappwebview.callHandler('flutterSetHoriVerti', isFull)
}

export const flutterDownloadH5Url = (url: string) => {
  window.flutter_inappwebview.callHandler('flutterDownloadH5Url', url)
}

export const closeWebview = () => {
  window.flutter_inappwebview.callHandler('flutterH5LoginOutFrmHome', '')
}
